import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  "aria-live": "assertive",
  class: "pointer-events-none inset-0 flex items-end px-4 py-4 sm:items-start sm:p-6 sm:py-4"
}
const _hoisted_2 = { class: "flex w-full flex-col items-center space-y-4 sm:items-end" }
const _hoisted_3 = { class: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5" }
const _hoisted_4 = { class: "p-4 relative" }
const _hoisted_5 = { class: "flex items-start" }
const _hoisted_6 = { class: "flex-shrink-0" }
const _hoisted_7 = { class: "ml-3 w-0 flex-1 pt-0.5" }
const _hoisted_8 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_9 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_10 = { class: "ml-4 flex flex-shrink-0" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckCircle = _resolveComponent("CheckCircle")!
  const _component_InformationCircle = _resolveComponent("InformationCircle")!
  const _component_ExclamationCircle = _resolveComponent("ExclamationCircle")!
  const _component_XMark = _resolveComponent("XMark")!
  const _component_notifications = _resolveComponent("notifications")!

  return (_openBlock(), _createBlock(_component_notifications, {
    position: "top right",
    max: 3,
    duration: 5000,
    width: "24rem"
  }, {
    body: _withCtx((props) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (props.item.type === 'success')
                    ? (_openBlock(), _createBlock(_component_CheckCircle, {
                        key: 0,
                        class: "h-6 w-6 text-green-500"
                      }))
                    : _createCommentVNode("", true),
                  (props.item.type === 'warn')
                    ? (_openBlock(), _createBlock(_component_InformationCircle, {
                        key: 1,
                        class: "h-6 w-6 text-yellow-500"
                      }))
                    : _createCommentVNode("", true),
                  (props.item.type === 'error')
                    ? (_openBlock(), _createBlock(_component_ExclamationCircle, {
                        key: 2,
                        class: "h-6 w-6 text-red-600"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(props.item.title), 1),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(props.item.text), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: props.close,
                    class: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-800 focus:ring-offset-2"
                  }, [
                    _hoisted_12,
                    _createVNode(_component_XMark, { class: "w-5 h-5" })
                  ], 8, _hoisted_11)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}